import { ClientBannerType } from '../../interfaces/client'
import { FilterFieldType, IFilter } from './types'

export const CLIENT_BANNERS_LIST_FILTERS_CONFIG = [
  {
    field: 'description',
    dbField: 'description',
    alias: 'clientBanner',
    type: FilterFieldType.Text,
    isSortable: true,
    title: 'Message',
  },
  {
    field: 'type',
    dbField: 'type',
    alias: 'clientBanner',
    type: FilterFieldType.List,
    isSortable: true,
    title: 'Type',
    options: [
      {
        value: ClientBannerType.Custom,
        label: 'Custom',
      },
      {
        value: ClientBannerType.Holiday,
        label: 'Holiday',
      },
      {
        value: ClientBannerType.PendingCashDominion,
        label: 'Cash Dominion',
      },
    ],
  },
  {
    field: 'clientName',
    dbField: 'client_name',
    alias: 'clientBanner',
    type: FilterFieldType.Autocomplete,
    isSortable: true,
    isMultiple: true,
    title: 'Target',
    placeholder: 'Client',
  },
  {
    field: 'startDate',
    dbField: 'start_date',
    alias: 'clientBanner',
    type: FilterFieldType.Date,
    isSortable: true,
    title: 'Start Date',
  },
  {
    field: 'endDate',
    dbField: 'end_date',
    alias: 'clientBanner',
    type: FilterFieldType.Date,
    isSortable: true,
    title: 'End Date',
  },
  {
    field: 'status',
    type: FilterFieldType.Empty,
    title: 'Status',
  },
  {
    field: 'action',
    type: FilterFieldType.Empty,
    title: 'Action',
    align: 'right',
  },
  {
    type: FilterFieldType.QuickFilter,
    field: 'quickFilter',
    fields: [
      {
        field: 'activeOnly',
        type: FilterFieldType.Boolean,
      },
    ],
    quickFilters: [
      {
        title: 'Active',
        filters: {
          activeOnly: 'true',
        },
      },
    ],
  },
] as const satisfies IFilter[]
